import { Pagination } from 'services/search';
import { PaginationDirection } from 'services/url';

export const initialPagination: Pagination = {
  pageNumber: 1,
  pageSize: 20,
  sort: {
    sortBy: 'created',
    direction: PaginationDirection.Descending,
  },
  totalCount: 20,
  totalPages: 0,
};

export interface DataWithPagination<T = any> {
  pagination: Pagination;
  data: T[];
}

export const initialDataWithPagination: DataWithPagination = {
  data: [],
  pagination: { ...initialPagination, pageSize: 20 },
};
